module.exports = __webpack_public_path__ + "media/images/flags/LI-9ad1aa1ac87103df6bbbf22538262dad.svg";